import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, Group } from '../../../../models';
import { groupForbiddenCharacters, groupForbiddenStartingCharacters, groupAdded } from '../../../../common/';
import { ITemplateService, ILoggerService } from '../../../../services';

interface IduplicateFormCtrl extends angular.IFormController {
    newGroupName: angular.INgModelController;
}

class CreateFromTemplateModalController implements angular.IComponentController {
    formCtrl: IduplicateFormCtrl;
    newGroupName: string;

    readonly group: Group; // The parent of the group that  will be created.
    readonly groups: Group[]; // The list of all groups in the model (bound, for validation).
    readonly modalId: string;
    readonly onGroupCreated: ({ group: any }) => void;
    readonly templateGuid: string;

    static $inject = ['$rootScope', 'templateService', 'loggerService'];

    constructor(
        private _$rootScope: angular.IRootScopeService,
        private _templateService: ITemplateService,
        private _loggerService: ILoggerService
    ) {
    }


    $onInit() {
        angular.element(`#${this.modalId}`)
            .on('hidden.bs.modal', () => {
                this.clear();
            });
    }

    create() {
        this._templateService.createGroup(this.templateGuid, this.group.guid, this.newGroupName)
            .then(data => {
                this._loggerService.logSuccess('Group successfully created!');
                this._$rootScope.$broadcast(groupAdded, data);
                if (this.onGroupCreated) {
                    this.onGroupCreated({ group: data });
                }
            })
            .catch(reason => {
                console.log(reason);
                this._loggerService.logError('Failed to create group');
            })
            .finally(() => {
                this.clear();
            });
    }

    validateName() {
        this.checkForbidden();
        this.checkDuplicate();
    }

    clear() {
        this.newGroupName = '';
        this.formCtrl.$setPristine();
    }

    private checkForbidden() {
        const newName = this.formCtrl.newGroupName.$viewValue.toLowerCase();
        const isValid = !_.some(newName, c => groupForbiddenCharacters.indexOf(String(c)) >= 0) &&
            !_.some(groupForbiddenStartingCharacters, c => _.startsWith(newName, c));

        this.formCtrl.newGroupName.$setValidity('forbidden', isValid);
    }

    private checkDuplicate() {
        const isValid = !_.some(this.groups, t => t.parentGUID === this.group.guid && t.name.toLowerCase() === this.formCtrl.newGroupName.$viewValue.toLowerCase());
        this.formCtrl.newGroupName.$setValidity('duplicate', isValid);
    }
}

export const wtCreateFromTemplateModal: ComponentDefinition = {
    componentId: 'wtCreateFromTemplateModal',
    controller: CreateFromTemplateModalController,
    template: require('./createFromTemplateModal.component.html'),
    controllerAs: 'vm',
    bindings: {
        group: '<',
        modalId: '@',
        groups: '<',
        templateGuid: '<',
        onGroupCreated: '&?'
    }
};